export class FaqModel {
    system: string;
    question: string;
    answer: string;
    id?: number;
}
